import { Component, OnInit, Input } from '@angular/core';
import {
	Router,
	ActivatedRoute,
	NavigationEnd,
	Params,
	PRIMARY_OUTLET
} from '@angular/router';

interface IBreadcrumb {
	label: string;
	params: Params;
	url: string;
}

@Component({
	selector: 'app-breadcrums',
	templateUrl: './breadcrums.component.html',
	styleUrls: ['./breadcrums.component.css']
})
export class BreadcrumsComponent implements OnInit {
	public breadcrumbs: IBreadcrumb[];
	@Input() breadCrumbLabel = '';
	/**
	 * @class DetailComponent
	 * @constructor
	 */
	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {
		this.breadcrumbs = [];
	}

	/**
	 * Let's go!
	 *
	 * @class DetailComponent
	 * @method ngOnInit
	 */
	ngOnInit() {
		const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

		// subscribe to the NavigationEnd event
		this.router.events.subscribe(event => {
      if(event => event instanceof NavigationEnd) {
				const root: ActivatedRoute = this.activatedRoute.root;

				this.breadcrumbs = this.getBreadcrumbs(root);
      }
    });
	}
	goToDashboard() {
		// Need to write logic to get root routes so that it will not go to base url
		// this.router.navigate(['/']);
		const r = this.router.url;
		const routeArr = r.split('/');
		const slicedArr = routeArr.slice(0, 2);
		this.router.navigate([`/${slicedArr[1]}`]);
	}
	// TO navigate to breadcrums links
	navigate(breadcrum) {
		const r = this.router.url;
		const routeArr = r.split('/');
		const findIndex = routeArr.indexOf(breadcrum.url.substring(1, breadcrum.url.length));
		const slicedArr = routeArr.slice(0, findIndex + 1);
		this.router.navigate([`/${slicedArr.join('/')}`, breadcrum.params]);
	}

	/**
	 * Returns array of IBreadcrumb objects that represent the breadcrumb
	 *
	 * @class DetailComponent
	 * @method getBreadcrumbs
	 * @param {ActivateRoute} route
	 * @param {string} url
	 * @param {IBreadcrumb[]} breadcrumbs
	 */
	private getBreadcrumbs(
		route: ActivatedRoute,
		url: string = '',
		breadcrumbs: IBreadcrumb[] = []
	): IBreadcrumb[] {
		const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

		// get the child routes
		const children: ActivatedRoute[] = route.children;

		// return if there are no more children
		if (children.length === 0) {
			return breadcrumbs;
		}

		// iterate over each children
		for (const child of children) {
			// verify primary route
			if (child.outlet !== PRIMARY_OUTLET) {
				continue;
			}

			// verify the custom data property "breadcrumb" is specified on the route
			if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
				return this.getBreadcrumbs(child, url, breadcrumbs);
			}

			// get the route's URL segment
			const routeURL: string = child.snapshot.url
				.map(segment => segment.path)
				.join('/');

			// append route URL to URL
			url += `/${routeURL}`;

			// add breadcrumb
			const breadcrumb: IBreadcrumb = {
				label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
				params: child.snapshot.params,
				url: url
			};
			breadcrumbs.push(breadcrumb);

			// recursive
			return this.getBreadcrumbs(child, url, breadcrumbs);
		}
	}
}
